import { FEATURE_FLAGS } from "../constants/featureFlags";

let useGenerativeGlobal = false;

export const useGenerativeVoiceGlobal = () => {
  return useGenerativeGlobal || FEATURE_FLAGS.UNIVERSAL_GENERATIVE_VOICE;
}

export const setUseGenerativeVoiceGlobal = (useGenerative) => {
  useGenerativeGlobal = useGenerative;
}

export const TTS_ENGINE_TYPE = {
  standard: 'standard',
  generative: 'generative',
};

export const createRandomSpeechMarks = () => {
  const numAudioChars = 400; // Gives up to 60 seconds of random visemes
  const visemesChars = ['u', 't', 's', 'o', 'i', 'r', 'e', 'a'];
  const silentViseme = 'sil';
  const randomVisemes = [];

  let totalTime = 0;
  let inSilent = false;

  for (let i = 0; i < numAudioChars; i++){

    const randomNum = Math.random();
    if (!inSilent && randomNum >= 0.9) {
      inSilent = true;
    } else {
      inSilent = false;
    }

    randomVisemes.push({
      type: 'viseme',
      value: inSilent ? silentViseme : visemesChars[Math.floor(Math.random() * visemesChars.length)],
      time: totalTime
    });

    totalTime += inSilent ? 300 : 150;
  }

  return [
    {
      words: [
        {
          type: 'word',
          visemes: randomVisemes
        }
      ]
    }
  ];
}